import React from "react";
import "./Card.css";

function Card({ children, className = "", role = "", ariaLabel = "", dataTextId, onClick }) {


    return (
        <div className={`card level-1 ${className}`}
            role={role}
            aria-label={ariaLabel}
            onClick={onClick}
            data-testid={dataTextId}>
            {children}
        </div>
    );
}

export default React.memo(Card);
